import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["tabButton", "panel"]

  select(event) {
    const tabId = event.currentTarget.dataset.tab
    if (!tabId) return

    // Plan/profile tabs use .section-tab; legacy markup uses .tab-btn on the
    // clickable element. Always toggle active on the styled wrapper, not an
    // inner <button> nested inside .section-tab.
    const tabEl = (el) => el.closest(".section-tab") || el.closest(".tab-btn") || el

    this.tabButtonTargets.forEach((btn) => {
      const el = tabEl(btn)
      el.classList.remove("active")
      if (el.classList.contains("tab-btn")) {
        el.classList.remove("shadow-card")
        el.classList.add("shadow-none")
      }
    })

    const activeEl = tabEl(event.currentTarget)
    activeEl.classList.add("active")
    if (activeEl.classList.contains("tab-btn")) {
      activeEl.classList.add("shadow-card")
      activeEl.classList.remove("shadow-none")
    }

    this.panelTargets.forEach((panel) => panel.classList.remove("active"))
    const targetPanel = this.panelTargets.find((p) => p.id === tabId)
    if (targetPanel) targetPanel.classList.add("active")
  }
}
